import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useMemo, useRef, useState, useEffect } from 'react';
import { WidthProvider, Responsive } from 'react-grid-layout';
import { createUseStyles } from 'hoi-poi-ui';
import classnames from 'classnames';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'GridLayout');
const ResponsiveGridLayout = WidthProvider(Responsive);
const ROW_HEIGHT = 24;
const MARGIN = 16;
const GridLayout = /*#__PURE__*/memo(_ref => {
  let {
    widgets,
    layouts,
    layout,
    onResize,
    onResizeStop,
    onDrag,
    onDragStop,
    onLayoutChange,
    selected,
    canDrag = false,
    canResize = false,
    adaptativeHeight = false
  } = _ref;
  const gridRef = useRef();
  const [gridHeight, setGridHeight] = useState();
  const classes = useStyles();
  useEffect(() => {
    const gridObserver = new ResizeObserver(() => {
      setGridHeight(gridRef.current.offsetHeight);
    });
    gridObserver.observe(gridRef.current);
    return () => gridObserver.disconnect();
  }, [adaptativeHeight]);
  const baseLayout = useMemo(() => ({
    isBound: true,
    isDraggable: canDrag,
    isResizable: canResize
  }), [canDrag, canResize]);
  const finalLayout = useMemo(() => {
    return (layout === null || layout === void 0 ? void 0 : layout.map(current => _objectSpread(_objectSpread(_objectSpread({}, baseLayout), current), {}, {
      i: current.i.toString()
    }))) || [];
  }, [baseLayout, layout]);
  const layoutProps = useMemo(() => {
    let rowHeight = adaptativeHeight ? gridHeight / 24 - MARGIN + 0.5 : ROW_HEIGHT;
    if (rowHeight < 16) rowHeight = 16;
    let baseProps = {
      layouts: layouts ? layouts : {
        lg: finalLayout
      },
      breakpoints: {
        lg: 1000,
        md: 796,
        sm: 568,
        xs: 280,
        xxs: 0
      },
      cols: {
        lg: 24,
        md: 16,
        sm: 16,
        xs: 8,
        xxs: 8
      },
      rowHeight: rowHeight,
      margin: [MARGIN, MARGIN],
      containerPadding: [0, 0],
      onLayoutChange,
      onResize,
      onResizeStop,
      onDrag,
      onDragStop,
      resizeHandles: ['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne']
    };
    return baseProps;
  }, [layouts, finalLayout, adaptativeHeight, gridHeight, onLayoutChange, onResize, onResizeStop, onDrag, onDragStop]);
  const renderWidgets = useMemo(() => {
    if (!(widgets !== null && widgets !== void 0 && widgets.length)) return;
    return widgets.map(current => {
      const isSelected = selected === null || selected === void 0 ? void 0 : selected.includes(current.id);
      return /*#__PURE__*/React.createElement("div", {
        key: current.id.toString(),
        className: classnames(classes.gridItem, {
          [classes.selected]: isSelected
        })
      }, current.content);
    });
  }, [widgets, classes.gridItem, classes.selected, selected]);
  return /*#__PURE__*/React.createElement("div", {
    ref: gridRef,
    className: classes.root
  }, gridHeight && /*#__PURE__*/React.createElement(ResponsiveGridLayout, layoutProps, renderWidgets));
});
export default GridLayout;